import { FieldWrapperProps as ClueyFieldWrapperProps, ErrorText, Label } from '@cluey/cluey-components';
import classNames from 'classnames';

/**
 * Local drop-in replacement for cluey-components' FieldWrapper that forwards
 * `className` to the outer div, since the library component doesn't support it.
 */
interface FieldWrapperProps extends ClueyFieldWrapperProps {
  className?: string;
}

export const FieldWrapper = ({ label, id, optional, error, className, children }: FieldWrapperProps) => (
  <div className={classNames('flex flex-col gap-1', className)}>
    <Label id={id} optional={optional}>
      {label}
    </Label>
    {children}
    {error && typeof error === 'string' && <ErrorText>{error}</ErrorText>}
  </div>
);
